var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import classnames from 'classnames';
import styles from '../_shared/components/GameCanvas/Game.module.css';
import { GameCanvas } from '../_shared/components/GameCanvas/GameCanvas';
import { GameLoader } from '../_shared/components/Loader/Loader';
import { EnumArkMessages } from '../_shared/models/EnumArkMessages';
import { EnumIframeAuthActions } from '../_shared/models/EnumIframeAuthActions';
import { EnumIframeMessageTypes } from '../_shared/models/EnumIframeMessageTypes';
import { EnumPlatformEventTypes } from '../_shared/models/EnumPlatformEventTypes';
import { EnumPurchaseEventLsListenedProps } from '../_shared/models/EnumPurchaseEventLsListenedProps';
import { CookieService } from '../_shared/services/CookieService';
import { FingerprintService } from '../_shared/services/FingerprintService';
import { AppInsightService } from '../_shared/services/AppInsightService';
import { DeviceDetector } from '../_shared/services/DeviceDetectorService';
import { GameObservable } from '../_shared/services/GameObservable';
import { LocalStorageService, lsDispatchGamePurchaseRequest, lsRemoveGamePurchaseRequest, lsSetGamePurchaseRequest } from '../_shared/services/LocalStorageService';
import { checkFPS } from '../_shared/utilites/checkFPS';
import { loadScript } from '../_shared/utilites/loadScript';
import { TypeEnvType } from '../_shared/models/TypeEnvType';
import { DBStorageInstance } from '../_shared/services/DBStorageService';
import { CONSTS } from './index.consts';
import { LifecycleEvent } from '../_shared/models/SdkLifecycleEvents';
import { AnalyticsProviderType } from '../_shared/models/SdkAnalytics';
import { logger } from '../_shared/utilites/logger';
export var makeGameResume = function () {
  return typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.dispatchEvent(new Event(EnumPlatformEventTypes.BACK_TO_GAME)));
};
export var setGamePurchaseRequestResult = function (isSuccess, isInNewTab) {
  if (isInNewTab === void 0) {
    isInNewTab = false;
  }
  if (isSuccess === null) {
    return lsRemoveGamePurchaseRequest();
  }
  var result = isSuccess ? 'success' : 'fail';
  var request = isInNewTab ? lsSetGamePurchaseRequest : lsDispatchGamePurchaseRequest;
  request(result);
  setTimeout(lsRemoveGamePurchaseRequest, 200);
};
function getArkadiumSDKEnv(env) {
  if (env === 'dev') {
    return 'DEV';
  } else if (env === 'staging') {
    return 'STAGING';
  } else {
    return 'PROD';
  }
}
var GameRenderingModule = /** @class */function (_super) {
  __extends(GameRenderingModule, _super);
  function GameRenderingModule(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      isGameLoading: true,
      isIframeLoaded: false,
      dbName: '',
      isArkadiumSdkGame: _this.isArkadiumSdkGame,
      gameRenderingUrl: null
    };
    _this.gameSubject = new GameObservable();
    _this.unitContainerRef = React.createRef();
    _this.canvasContainerRef = React.createRef();
    _this.doGameEndTrigger = true;
    _this.doGameScoresTrigger = true;
    _this.iframeRef = React.createRef();
    _this.deviceDetector = new DeviceDetector();
    // SEND MESSAGE TO IFRAME
    _this.postMessageToIframe = function (data) {
      return __awaiter(_this, void 0, void 0, function () {
        var iframeRef, serializedData;
        var _this = this;
        var _a;
        return __generator(this, function (_b) {
          iframeRef = (_a = this === null || this === void 0 ? void 0 : this.iframeRef) === null || _a === void 0 ? void 0 : _a.current;
          serializedData = JSON.parse(JSON.stringify(data));
          setTimeout(function () {
            var _a, _b;
            logger.log('GRM postMessage UNIT-OUT', data, iframeRef, serializedData);
            (_b = (_a = iframeRef === null || iframeRef === void 0 ? void 0 : iframeRef.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) === null || _b === void 0 ? void 0 : _b.call(_a, serializedData, _this.iframeSourceCode.replace(/\?.*/gi, '') || '*');
          }, 5);
          return [2 /*return*/];
        });
      });
    };
    // GET MESSAGE FROM IFRAME
    _this.onMessage = function (event) {
      try {
        if (event.data && event.data.actionName === EnumArkMessages.SET_GAME_TYPE) {
          _this.onResize();
        }
      } catch (ex) {
        logger.error(ex);
      }
    };
    _this.onGameEvent = function (event) {
      return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
          // this is to keep sequence of asynchroniously fired events in the event loop
          setTimeout(function () {
            return __awaiter(_this, void 0, void 0, function () {
              var _a, _b;
              return __generator(this, function (_c) {
                switch (_c.label) {
                  case 0:
                    return [4 /*yield*/, this.onGameEventBasic(event)];
                  case 1:
                    _c.sent();
                    return [4 /*yield*/, (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.onPlatformSpecificEvent) === null || _b === void 0 ? void 0 : _b.call(_a, event)];
                  case 2:
                    _c.sent();
                    return [2 /*return*/];
                }
              });
            });
          }, 0);
          return [2 /*return*/];
        });
      });
    };
    _this.onGameEventBasic = function (baseEvent) {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, onScoreChange, onGameEnd, onRewardStart, onInterstitialStart, isIframeGame, event, _b, type, payload;
        var _this = this;
        var _c;
        return __generator(this, function (_d) {
          _a = this.props, onScoreChange = _a.onScoreChange, onGameEnd = _a.onGameEnd, onRewardStart = _a.onRewardStart, onInterstitialStart = _a.onInterstitialStart, isIframeGame = _a.isIframeGame;
          event = isIframeGame && (((_c = this.iframeSourceCode) === null || _c === void 0 ? void 0 : _c.startsWith(baseEvent.origin)) || baseEvent.origin === window.location.origin) ? baseEvent.data : baseEvent;
          _b = event || {}, type = _b.type, payload = _b.payload;
          if (!type) {
            return [2 /*return*/];
          }
          try {
            // to keep sequence of events proceeded explicitly
            setTimeout(function () {
              return __awaiter(_this, void 0, void 0, function () {
                var _a, forceUpdate, _b, key, value, payload_1, key, _c, auth_method, auth_method_args, authApi;
                var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                return __generator(this, function (_q) {
                  switch (_q.label) {
                    case 0:
                      logger.log('GRM postMessage UNIT-IN', event, baseEvent);
                      _a = type;
                      switch (_a) {
                        case EnumIframeMessageTypes.TEST_READY:
                          return [3 /*break*/, 1];
                        case EnumIframeMessageTypes.UPDATE_LOCAL_STORAGE:
                          return [3 /*break*/, 2];
                        case EnumIframeMessageTypes.GAME_START:
                          return [3 /*break*/, 3];
                        case EnumIframeMessageTypes.EVENT_CHANGE:
                          return [3 /*break*/, 4];
                        case EnumIframeMessageTypes.CHANGE_SCORE:
                          return [3 /*break*/, 5];
                        case EnumIframeMessageTypes.GAME_END:
                          return [3 /*break*/, 6];
                        case EnumIframeMessageTypes.REWARD_START:
                          return [3 /*break*/, 7];
                        case EnumIframeMessageTypes.INTERSTITIAL_START:
                          return [3 /*break*/, 8];
                        case EnumIframeMessageTypes.SET_LS_ITEM:
                          return [3 /*break*/, 9];
                        case EnumIframeMessageTypes.REMOVE_LS_ITEM:
                          return [3 /*break*/, 10];
                        case EnumIframeMessageTypes.AD_REFRESH:
                          return [3 /*break*/, 11];
                        case EnumIframeMessageTypes.PURCHASE_UPDATE:
                          return [3 /*break*/, 12];
                        case EnumIframeMessageTypes.PURCHASE_REQUEST:
                          return [3 /*break*/, 13];
                        case EnumIframeMessageTypes.UPDATE_INDEXED_DB:
                          return [3 /*break*/, 14];
                        case EnumIframeMessageTypes.AUTH_API_EVENT:
                          return [3 /*break*/, 16];
                      }
                      return [3 /*break*/, 17];
                    case 1:
                      {
                        this.setState({
                          isGameLoading: false
                        });
                        (_e = (_d = this.props) === null || _d === void 0 ? void 0 : _d.onGameTestReady) === null || _e === void 0 ? void 0 : _e.call(_d);
                        return [3 /*break*/, 18];
                      }
                      _q.label = 2;
                    case 2:
                      if (payload) {
                        Object.keys(payload).forEach(function (key) {
                          LocalStorageService.setItem(key, payload[key]);
                        });
                      }
                      return [3 /*break*/, 18];
                    case 3:
                      (_g = (_f = this.props) === null || _f === void 0 ? void 0 : _f.onGameStart) === null || _g === void 0 ? void 0 : _g.call(_f);
                      return [3 /*break*/, 18];
                    case 4:
                      (_h = this === null || this === void 0 ? void 0 : this.props) === null || _h === void 0 ? void 0 : _h.doAdsRefresh();
                      return [3 /*break*/, 18];
                    case 5:
                      {
                        forceUpdate = event.forceUpdate;
                        if (!forceUpdate && this.doGameScoresTrigger) {
                          this.doGameScoresTrigger = false;
                          if (onScoreChange) {
                            onScoreChange(event);
                          }
                        } else if (forceUpdate && onScoreChange) {
                          onScoreChange(event);
                        }
                        return [3 /*break*/, 18];
                      }
                      _q.label = 6;
                    case 6:
                      if (this.doGameEndTrigger) {
                        this.props.doAdsRefresh();
                        this.doGameEndTrigger = false;
                      }
                      if (onGameEnd) {
                        onGameEnd(event);
                      }
                      return [3 /*break*/, 18];
                    case 7:
                      {
                        onRewardStart(payload);
                        return [3 /*break*/, 18];
                      }
                      _q.label = 8;
                    case 8:
                      {
                        onInterstitialStart(payload);
                        return [3 /*break*/, 18];
                      }
                      _q.label = 9;
                    case 9:
                      {
                        _b = payload || {}, key = _b.key, value = _b.value;
                        if (key && value) {
                          LocalStorageService.setItem(key, value);
                        }
                        return [3 /*break*/, 18];
                      }
                      _q.label = 10;
                    case 10:
                      {
                        payload_1 = event.payload;
                        key = (payload_1 || {}).key;
                        if (key) {
                          LocalStorageService.removeItem(key);
                        }
                        return [3 /*break*/, 18];
                      }
                      _q.label = 11;
                    case 11:
                      this.props.doAdsRefresh();
                      return [3 /*break*/, 18];
                    case 12:
                      (_j = this === null || this === void 0 ? void 0 : this.props) === null || _j === void 0 ? void 0 : _j.doUpdateGemsAmount();
                      return [3 /*break*/, 18];
                    case 13:
                      this.gamePurchaseEventHandler.bind(this)(event);
                      return [3 /*break*/, 18];
                    case 14:
                      return [4 /*yield*/, this.updateIndexedDB(payload)];
                    case 15:
                      _q.sent();
                      return [3 /*break*/, 18];
                    case 16:
                      {
                        _c = payload || {}, auth_method = _c.auth_method, auth_method_args = _c.auth_method_args;
                        authApi = this.props.authApiService;
                        if (auth_method_args) {
                          //@ts-expect-error issue in typing arguments
                          (_k = authApi === null || authApi === void 0 ? void 0 : authApi[auth_method]) === null || _k === void 0 ? void 0 : _k.call.apply(_k, __spreadArray([authApi], auth_method_args, false));
                        } else {
                          //@ts-expect-error issue in typing arguments
                          (_l = authApi === null || authApi === void 0 ? void 0 : authApi[auth_method]) === null || _l === void 0 ? void 0 : _l.call(authApi);
                        }
                        switch (auth_method) {
                          case 'openWidget':
                            return [2 /*return*/, !this.props.user && ((_o = (_m = this === null || this === void 0 ? void 0 : this.props) === null || _m === void 0 ? void 0 : _m.doOpenMenuLogin) === null || _o === void 0 ? void 0 : _o.call(_m))];
                          case 'subscribeToUserAuthStatus':
                            if ((_p = this.props) === null || _p === void 0 ? void 0 : _p.user) {
                              this.postMessageToIframe({
                                type: EnumIframeMessageTypes.AUTH_API_EVENT,
                                payload: {
                                  auth_method: auth_method,
                                  payload: __assign(__assign({}, this.props.user), {
                                    subscriptionId: this.props.subscriptionId,
                                    subscriptionPlan: this.props.subscriptionPlan,
                                    localStorage: __assign({}, JSON.parse(JSON.stringify(window.localStorage)))
                                  })
                                }
                              });
                            }
                            break;
                          default:
                            break;
                        }
                      }
                      return [3 /*break*/, 18];
                    case 17:
                      return [3 /*break*/, 18];
                    case 18:
                      return [2 /*return*/];
                  }
                });
              });
            }, 5);
          } catch (e) {
            logger.log('GRM postMessage UNIT-IN ERROR', e);
            // fallback to resume game if no response from game in 1 second in any case
            setTimeout(function () {
              _this.gameSubject.dispatch({
                type: EnumIframeMessageTypes.GAME_RESUME
              }, _this.props.isIframeGame ? _this.postMessageToIframe : null);
              if (_this.props.isIframeGame) {
                _this.postMessageToIframe({
                  type: EnumIframeMessageTypes.GAME_RESUME
                });
              }
            }, 1000);
          }
          return [2 /*return*/];
        });
      });
    };
    _this.gamePurchaseRequestsQueue = [];
    _this.gamePurchaseEventHandler = function (event) {
      var _a;
      var _b, _c;
      var purchaseRequestId = event.payload.payload;
      _this.gamePurchaseRequestsQueue.push(purchaseRequestId);
      lsSetGamePurchaseRequest('pending');
      LocalStorageService.addStorageListening((_a = {}, _a[EnumPurchaseEventLsListenedProps.GAME_PURCHASE_REQUEST] = _this.gamePurchaseStorageHandler, _a));
      (_c = (_b = _this.props) === null || _b === void 0 ? void 0 : _b.doOpenMenuPurchase) === null || _c === void 0 ? void 0 : _c.call(_b);
    };
    _this.gamePurchaseStorageHandler = function (event) {
      var newValue = event.newValue;
      logger.log('GRM: gamePurchaseStorageHandler', newValue);
      if (newValue === 'success') {
        _this.gamePurchaseEventSendResponse(true);
      } else if (newValue === 'fail') {
        _this.gamePurchaseEventSendResponse(false);
      }
      _this.props.doCloseMenu();
      _this.gamePurchaseRequestsQueue = [];
      lsRemoveGamePurchaseRequest();
      _this.postMessageToIframe({
        type: EnumIframeMessageTypes.GAME_RESUME
      });
      LocalStorageService.removeStorageListening(EnumPurchaseEventLsListenedProps.GAME_PURCHASE_REQUEST);
    };
    _this.gamePurchaseEventSendResponse = function (isSuccess) {
      var _a;
      var gamePurchaseRequestsQueue = __spreadArray([], _this.gamePurchaseRequestsQueue, true);
      (_a = gamePurchaseRequestsQueue === null || gamePurchaseRequestsQueue === void 0 ? void 0 : gamePurchaseRequestsQueue.forEach) === null || _a === void 0 ? void 0 : _a.call(gamePurchaseRequestsQueue, function (id, index) {
        var _a, _b, _c;
        var result = index === gamePurchaseRequestsQueue.length - 1 && isSuccess;
        var responseEvent = {
          type: EnumIframeMessageTypes.PURCHASE_RESPONSE,
          payload: {
            payload: id,
            result: result
          }
        };
        var sdkInst = _this.getArkadiumSdkInstance();
        (_b = (_a = sdkInst === null || sdkInst === void 0 ? void 0 : sdkInst.purchases) === null || _a === void 0 ? void 0 : _a.ui) === null || _b === void 0 ? void 0 : _b.shopWindowClosed(Boolean(result)); //SDK v1 support
        (_c = sdkInst === null || sdkInst === void 0 ? void 0 : sdkInst.host) === null || _c === void 0 ? void 0 : _c.purchaseFormClosed(Boolean(result)); //SDK v2 support
        _this.gameSubject.dispatch(responseEvent, _this.props.isIframeGame ? _this.postMessageToIframe : null);
        if (_this.props.isIframeGame) {
          _this.postMessageToIframe(responseEvent);
        }
      });
    };
    _this.onResize = function () {
      var _a, _b;
      _this.onResizeBasic();
      (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.onResize) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    _this.onResizeBasic = function () {};
    _this.onBackToGame = function () {
      setGamePurchaseRequestResult(false, false);
      _this.postMessageToIframe({
        type: EnumIframeMessageTypes.GAME_RESUME
      });
      LocalStorageService.removeStorageListening(EnumPurchaseEventLsListenedProps.GAME_PURCHASE_REQUEST);
    };
    _this.getIncognitoSdkOptions = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var isServer, aiUserId, storeUser, userEagleId, fingerprintGlobalCDs, browser, incognitoSdkOptions;
        var _a, _b;
        return __generator(this, function (_c) {
          isServer = this.props.isServer;
          if (isServer) {
            return [2 /*return*/, {
              fpVisitorId: 'unknown',
              fpIncognito: 'unknown'
            }];
          }
          aiUserId = (CookieService.getArkCookie('ai_user') || '|').split('|')[0];
          storeUser = (_b = (_a = window === null || window === void 0 ? void 0 : window.STORE) === null || _a === void 0 ? void 0 : _a.getState) === null || _b === void 0 ? void 0 : _b.call(_a).user;
          userEagleId = storeUser === null || storeUser === void 0 ? void 0 : storeUser.uid;
          fingerprintGlobalCDs = FingerprintService.detected;
          browser = this.deviceDetector.DetectBrowser();
          incognitoSdkOptions = __assign(__assign(__assign(__assign(__assign({}, aiUserId ? {
            aiUserId: aiUserId
          } : {}), fingerprintGlobalCDs), userEagleId ? {
            userEagleId: userEagleId
          } : {}), AppInsightService.getAnalyticsData()), {
            ClientBrowser: "".concat(browser.name, " ").concat(browser.version)
          });
          return [2 /*return*/, incognitoSdkOptions];
        });
      });
    };
    _this.initDB = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var slug, prefix, dbName;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              slug = this.props.game.slug;
              prefix = '____ark_game_crossword____';
              dbName = "".concat(prefix, "___").concat(slug, "___");
              this.setState({
                dbName: dbName
              });
              DBStorageInstance.postfix = slug;
              logger.debug('before init');
              return [4 /*yield*/, DBStorageInstance.init(prefix)];
            case 1:
              _a.sent();
              return [2 /*return*/, dbName];
          }
        });
      });
    };
    _this.updateIndexedDB = function (iframeIndexedDB) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              logger.debug('update indexed db in container ', iframeIndexedDB);
              return [4 /*yield*/, DBStorageInstance.setItem(this.state.dbName, iframeIndexedDB).then(function (res) {
                return logger.debug(res);
              })];
            case 1:
              _a.sent();
              return [2 /*return*/];
          }
        });
      });
    };
    _this.getIndexedDBData = function (dbName) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, DBStorageInstance.getItem(dbName)];
            case 1:
              return [2 /*return*/, _a.sent()];
          }
        });
      });
    };
    _this.onSdkIframeLoad = function () {
      if (_this.props.isServer) {
        return;
      }
      _this.setState({
        isIframeLoaded: true,
        isGameLoading: false
      });
    };
    _this.onIframeLoad = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var postMessageToIframe, options, storageData, _a, arenaDomain, game, arenaEnvironment, nestEnvironment, isCrossword, arenaIndexedDB, dbName, _b, storeState, store, arkadiumDomain, gameData;
        var _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
          switch (_h.label) {
            case 0:
              if (this.props.isServer) {
                return [2 /*return*/];
              }
              postMessageToIframe = this.postMessageToIframe;
              this.setState({
                isIframeLoaded: true
              });
              if (this.state.gameRenderingUrl) {
                this.setState({
                  isGameLoading: false
                });
              }
              return [4 /*yield*/, this.prepareOptionsForGame()];
            case 1:
              options = _h.sent();
              storageData = {
                type: EnumIframeMessageTypes.UPDATE_LOCAL_STORAGE,
                payload: __assign(__assign({}, JSON.parse(JSON.stringify(window.localStorage))), {
                  passedCookiesData: "".concat(document.cookie)
                })
              };
              _a = this.props, arenaDomain = _a.arenaDomain, game = _a.game, arenaEnvironment = _a.arenaEnvironment, nestEnvironment = _a.nestEnvironment;
              isCrossword = (_d = (_c = game === null || game === void 0 ? void 0 : game.slug) === null || _c === void 0 ? void 0 : _c.includes) === null || _d === void 0 ? void 0 : _d.call(_c, 'crossword');
              arenaIndexedDB = null;
              if (!isCrossword) return [3 /*break*/, 6];
              return [4 /*yield*/, this.initDB()];
            case 2:
              dbName = _h.sent();
              if (!isCrossword) return [3 /*break*/, 4];
              return [4 /*yield*/, this.getIndexedDBData(dbName)];
            case 3:
              _b = (_e = _h.sent()) !== null && _e !== void 0 ? _e : {};
              return [3 /*break*/, 5];
            case 4:
              _b = {};
              _h.label = 5;
            case 5:
              arenaIndexedDB = _b;
              logger.debug({
                arenaIndexedDB: arenaIndexedDB
              });
              _h.label = 6;
            case 6:
              storeState = ((_g = (_f = window === null || window === void 0 ? void 0 : window.STORE) === null || _f === void 0 ? void 0 : _f.getState) === null || _g === void 0 ? void 0 : _g.call(_f)) || {};
              store = __assign(__assign({}, storeState), {
                // check for non-character after arkadium to avoid http://www-dev4.arkadium.com/ https://pr20325.arkadium-sandbox.com/ https://arkadium.com
                config: __assign({}, storeState)
              });
              arkadiumDomain = arenaDomain.match(/\barkadium\b/gi) && !arenaDomain.includes('games.arkadium.com');
              gameData = {
                type: EnumIframeMessageTypes.PASS_GAME_DATA,
                // passedCookiesData is needed because undafe cookies are not taken by game in iframe
                payload: __assign(__assign({
                  localstorage: __assign(__assign({}, JSON.parse(JSON.stringify(window.localStorage))), {
                    passedCookiesData: "".concat(document.cookie)
                  }),
                  options: options,
                  game: game,
                  arenaName: arenaDomain
                }, arenaIndexedDB ? {
                  arenaIndexedDB: arenaIndexedDB
                } : {}), {
                  // store,
                  eaglePassedInGame: arkadiumDomain || this.props.eaglePassedInGame,
                  arenaEnvironment: arenaEnvironment,
                  nestEnvironment: nestEnvironment
                })
              };
              postMessageToIframe(storageData);
              postMessageToIframe(gameData);
              return [2 /*return*/];
          }
        });
      });
    };
    _this.onArkadiumSdkEvent = function (event, payload) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
      switch (event) {
        // case EnumIframeMessageTypes.TEST_READY: {
        case LifecycleEvent.TEST_READY:
          {
            logger.debug(event);
            _this.setState({
              isGameLoading: false
            });
            (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.onSdkGameTestReady) === null || _b === void 0 ? void 0 : _b.call(_a);
            break;
          }
        // case EnumIframeMessageTypes.GAME_START:
        case LifecycleEvent.GAME_START:
          logger.debug(event);
          (_d = (_c = _this.props) === null || _c === void 0 ? void 0 : _c.onSdkGameStart) === null || _d === void 0 ? void 0 : _d.call(_c);
          break;
        // case EnumIframeMessageTypes.EVENT_CHANGE:
        case LifecycleEvent.INTERACT:
          logger.debug(event);
          (_f = (_e = _this === null || _this === void 0 ? void 0 : _this.props) === null || _e === void 0 ? void 0 : _e.onSdkEventChange) === null || _f === void 0 ? void 0 : _f.call(_e);
          break;
        // case EnumIframeMessageTypes.CHANGE_SCORE:
        case LifecycleEvent.SCORE_CHANGED:
          {
            logger.debug(event, payload);
            var forceUpdate = event.forceUpdate;
            if (!forceUpdate && _this.doGameScoresTrigger) {
              _this.doGameScoresTrigger = false;
            }
            (_h = (_g = _this === null || _this === void 0 ? void 0 : _this.props) === null || _g === void 0 ? void 0 : _g.onSdkScoreChange) === null || _h === void 0 ? void 0 : _h.call(_g, event, payload);
            break;
          }
        case LifecycleEvent.GAME_END:
          logger.debug(event);
          (_k = (_j = _this === null || _this === void 0 ? void 0 : _this.props) === null || _j === void 0 ? void 0 : _j.onSdkGameEnd) === null || _k === void 0 ? void 0 : _k.call(_j, event);
          break;
        case LifecycleEvent.GEMS_UPDATE:
          logger.debug(event);
          (_l = _this === null || _this === void 0 ? void 0 : _this.props) === null || _l === void 0 ? void 0 : _l.doUpdateGemsAmount();
          break;
        default:
          break;
      }
    };
    _this.onOpenAuthRequest = function (isOpened) {
      var _a, _b;
      if (isOpened) {
        (_b = (_a = _this === null || _this === void 0 ? void 0 : _this.props) === null || _a === void 0 ? void 0 : _a.doOpenMenuLogin) === null || _b === void 0 ? void 0 : _b.call(_a);
      }
    };
    _this.loadArkadiumSdk = function (target) {
      var isDev = _this.props.arenaEnvironment === TypeEnvType.DEV;
      function getSDKURLWithMajor(major) {
        return "https://developers.arkadium.com/cdn/sdk/".concat(isDev ? 'dev/' : '', "v").concat(major, "/arena-sdk.js");
      }
      // check if ArenaSDK is already loaded
      var loadPromise;
      if (window.ArkadiumArenaSDK) {
        logger.log('SDK already loaded.');
        loadPromise = Promise.resolve();
      } else {
        var ARKADIUM_SDK_URL = getSDKURLWithMajor(2);
        logger.log('SDK not loaded.');
        loadPromise = loadScript(ARKADIUM_SDK_URL);
      }
      loadPromise.then(function () {
        return __awaiter(_this, void 0, void 0, function () {
          var env;
          var _this = this;
          return __generator(this, function (_a) {
            if (!window.ArkadiumArenaSDK) {
              return [2 /*return*/];
            }
            env = getArkadiumSDKEnv(this.props.arenaEnvironment);
            window.ArkadiumArenaSDK.onGameSDKLoaded(target, function (response) {
              return __awaiter(_this, void 0, void 0, function () {
                var sdkVersion, gameMajorVersion, arenaMajorVersion, instance, data, _i, _a, _b, key, value;
                var _this = this;
                var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                return __generator(this, function (_r) {
                  switch (_r.label) {
                    case 0:
                      sdkVersion = response === null || response === void 0 ? void 0 : response.sdkVersion;
                      gameMajorVersion = parseInt(sdkVersion.split('.')[0]);
                      arenaMajorVersion = parseInt((_d = (_c = window.ArkadiumArenaSDK) === null || _c === void 0 ? void 0 : _c.version.split('.')[0]) !== null && _d !== void 0 ? _d : '2.0.0');
                      logger.log('Game SDK LOADED:', sdkVersion);
                      logger.log('Arena SDK LOADED:', (_e = window.ArkadiumArenaSDK) === null || _e === void 0 ? void 0 : _e.version);
                      // hack because SDK is incorrectly versioned on npm vs cdn
                      if (gameMajorVersion === 0) {
                        gameMajorVersion = 1;
                      }
                      if (!(gameMajorVersion !== arenaMajorVersion)) return [3 /*break*/, 2];
                      logger.log("CHANGING SDK from v".concat(arenaMajorVersion, " to v").concat(gameMajorVersion));
                      (_f = window.ArkadiumArenaSDK) === null || _f === void 0 ? void 0 : _f.dispose();
                      delete window.ArkadiumArenaSDK;
                      return [4 /*yield*/, loadScript(getSDKURLWithMajor(gameMajorVersion))];
                    case 1:
                      _r.sent();
                      _r.label = 2;
                    case 2:
                      if (!window.ArkadiumArenaSDK) {
                        return [2 /*return*/];
                      }
                      return [4 /*yield*/, window.ArkadiumArenaSDK.getInstance(env, true)];
                    case 3:
                      instance = _r.sent();
                      return [4 /*yield*/, instance.initialize(env, false, (_g = this.props.authApiService) === null || _g === void 0 ? void 0 : _g.getSessionStorage())];
                    case 4:
                      _r.sent();
                      instance.lifecycle.subscribe(function (event, payload) {
                        return __awaiter(_this, void 0, void 0, function () {
                          var fingerprintData;
                          var _a, _b;
                          return __generator(this, function (_c) {
                            switch (_c.label) {
                              case 0:
                                this.onArkadiumSdkEvent(event, payload);
                                if (!(event === LifecycleEvent.TEST_READY && ((_a = instance.analytics) === null || _a === void 0 ? void 0 : _a.setFingerprintData))) return [3 /*break*/, 3];
                                fingerprintData = FingerprintService.detected;
                                if (!(!fingerprintData || fingerprintData.fpVisitorId === 'unknown')) return [3 /*break*/, 2];
                                return [4 /*yield*/, FingerprintService.init()];
                              case 1:
                                fingerprintData = _c.sent();
                                _c.label = 2;
                              case 2:
                                (_b = instance.analytics) === null || _b === void 0 ? void 0 : _b.setFingerprintData({
                                  fpVisitorId: fingerprintData === null || fingerprintData === void 0 ? void 0 : fingerprintData.fpVisitorId,
                                  fpIncognito: fingerprintData === null || fingerprintData === void 0 ? void 0 : fingerprintData.fpIncognito
                                });
                                _c.label = 3;
                              case 3:
                                return [2 /*return*/];
                            }
                          });
                        });
                      });
                      // handle different APIs from SDK
                      if (gameMajorVersion === 1) {
                        (_h = instance.userStateApi) === null || _h === void 0 ? void 0 : _h.authUIManager.openAuthRequest.subscribe(this.onOpenAuthRequest);
                        (_j = instance.purchases) === null || _j === void 0 ? void 0 : _j.ui.openRequest.subscribe(function (r) {
                          _this.gamePurchaseEventHandler({
                            type: EnumIframeMessageTypes.PURCHASE_REQUEST,
                            payload: r
                          });
                        });
                      } else {
                        (_k = instance.auth) === null || _k === void 0 ? void 0 : _k.onOpenAuthForm(this.onOpenAuthRequest);
                        (_l = instance.host) === null || _l === void 0 ? void 0 : _l.onOpenPurchaseForm(function (r) {
                          _this.gamePurchaseEventHandler({
                            type: EnumIframeMessageTypes.PURCHASE_REQUEST,
                            payload: r
                          });
                        });
                        data = (_o = (_m = this.props).getAnalyticsProvidersState) === null || _o === void 0 ? void 0 : _o.call(_m);
                        if (data) {
                          for (_i = 0, _a = Object.entries(data); _i < _a.length; _i++) {
                            _b = _a[_i], key = _b[0], value = _b[1];
                            if (!value) {
                              (_q = (_p = instance.analytics) === null || _p === void 0 ? void 0 : _p.disableProvider) === null || _q === void 0 ? void 0 : _q.call(_p, AnalyticsProviderType[key]);
                            }
                          }
                        }
                      }
                      instance.updateWinReference(target);
                      this.getArkadiumSdkInstance = function () {
                        return instance;
                      };
                      return [2 /*return*/];
                  }
                });
              });
            }, env);
            return [2 /*return*/];
          });
        });
      }).catch(function (err) {
        return logger.error('ARKADIUM_SDK_ERROR init', err);
      });
    };
    _this.loadGameSdk = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var gameAssetUrl, options;
        var _this = this;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              gameAssetUrl = this.gameAssetOriginUrl;
              return [4 /*yield*/, this.prepareOptionsForGame()];
            case 1:
              options = _a.sent();
              loadScript("".concat(gameAssetUrl, "main.min.js")).then(function () {
                var _a, _b;
                try {
                  var sdk = window.__arenax_v1__["".concat(_this.props.game.sdkName, "Game")].game;
                  sdk.register(_this.gameSubject, options);
                  window.__analyticsProvidersState__ = options.analyticsProvidersState;
                  (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.doSetGameObservable) === null || _b === void 0 ? void 0 : _b.call(_a, _this.gameSubject);
                  sdk.render(0, 0, 'game-canvas');
                } catch (e) {
                  logger.error(e);
                }
              });
              return [2 /*return*/];
          }
        });
      });
    };
    _this.prepareOptionsForGame = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var game, currentLang, eaglePassedInGame, authApi, paymentApi, virtualItemsApi, userGameDataApi, eagleLibs, assetOriginUrl, incognitoSdkOptions, options, abtestValue;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
          switch (_h.label) {
            case 0:
              game = this.props.game || {};
              currentLang = this.props.currentLang;
              eaglePassedInGame = (_a = this.props.eaglePassedInGame) !== null && _a !== void 0 ? _a : true;
              authApi = this.props.authApiService;
              paymentApi = this.props.paymentApiService;
              virtualItemsApi = this.props.virtualItemsApiService;
              userGameDataApi = this.props.userGameDataApiService;
              eagleLibs = {
                '@arkadium/eagle-user-client': authApi,
                '@arkadium/eagle-virtual-items-api-client': virtualItemsApi,
                '@arkadium/eagle-payments-api-client': paymentApi,
                userGameDataApi: userGameDataApi,
                nestEnvironment: this.props.nestEnvironment,
                arenaEnvironment: this.props.arenaEnvironment
              };
              assetOriginUrl = this.gameAssetOriginUrl;
              return [4 /*yield*/, this.getIncognitoSdkOptions()];
            case 1:
              incognitoSdkOptions = _h.sent();
              options = __assign({
                assetOriginUrl: assetOriginUrl,
                configUrl: this.gameExternalConfigUrl,
                locale: currentLang,
                rewardVideoAvailable: (_b = this.props.rewardVideoAvailable) !== null && _b !== void 0 ? _b : true,
                interstitialVideoAvailable: (_c = this.props.interstitialVideoAvailable) !== null && _c !== void 0 ? _c : true,
                eventList: [],
                arenaName: this.props.arenaDomain,
                analyticsProvidersState: (_e = (_d = this.props).getAnalyticsProvidersState) === null || _e === void 0 ? void 0 : _e.call(_d)
              }, incognitoSdkOptions);
              if (eaglePassedInGame && !this.props.isIframeGame) {
                options.enviroment = eagleLibs;
              }
              if (this.props.isIframeGame) {
                abtestValue = this.props.isServer ? null : (_g = (_f = window === null || window === void 0 ? void 0 : window.STORE) === null || _f === void 0 ? void 0 : _f.getState()) === null || _g === void 0 ? void 0 : _g.abTestsValue;
                options.sdkName = game.sdkName;
                options.abVariations = abtestValue;
              }
              return [2 /*return*/, options];
          }
        });
      });
    };
    return _this;
  }
  Object.defineProperty(GameRenderingModule.prototype, "gameId", {
    get: function () {
      if ('id' in this.props.game) {
        return String(this.props.game.id);
      }
      return null;
    },
    enumerable: false,
    configurable: true
  });
  GameRenderingModule.prototype.getAssetOriginUrl = function (sdkName, version) {
    var base = this.props.arenaDomain.includes('aarp') ? CONSTS.PATH_TO_GAMES_URL_AARP : CONSTS.PATH_TO_GAMES_URL;
    return "".concat(base).concat(sdkName, "/").concat(version, "/");
  };
  Object.defineProperty(GameRenderingModule.prototype, "gameAssetOriginUrl", {
    get: function () {
      var _a;
      var searchParams = new URLSearchParams(window.location.search);
      var game = this.props.game;
      var customGameApiURL = (_a = searchParams.get('gameApi')) !== null && _a !== void 0 ? _a : searchParams.get('gameAPI');
      if (customGameApiURL) {
        return customGameApiURL;
      }
      var customVersion = searchParams.get('version');
      var sdkName = game.renderingType === 'JavaScript' && game.sdkName ? game.sdkName : game.slug;
      if (customVersion) {
        return this.getAssetOriginUrl(sdkName, customVersion);
      }
      return this.getAssetOriginUrl(sdkName, game.version);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(GameRenderingModule.prototype, "gameExternalConfigUrl", {
    get: function () {
      if ('externalConfigUrl' in this.props.game) {
        return this.props.game.externalConfigUrl;
      }
      return '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(GameRenderingModule.prototype, "isArkadiumSdkGame", {
    get: function () {
      var urlParams = new URLSearchParams(window.location.search);
      var sdkFlag = '__sdk_demo_mode';
      return Boolean(urlParams.get(sdkFlag));
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(GameRenderingModule.prototype, "iframeSourceCode", {
    get: function () {
      var _a, _b, _c;
      if (typeof window === 'undefined') {
        return '';
      }
      if (this.state.isArkadiumSdkGame) {
        return CONSTS.IFRAME_DEMO_MODE_URL;
      }
      if (this.props.externalRenderingUrl && this.props.externalRenderingUrl !== '') {
        var urlParams_1 = new URLSearchParams();
        var topUrlParams = new URLSearchParams(window.location.search);
        urlParams_1.set('useSDKDevCDN', (_a = topUrlParams.get('useSDKDevCDN')) !== null && _a !== void 0 ? _a : 'false');
        return "".concat(this.props.externalRenderingUrl, "?").concat(urlParams_1.toString());
      }
      var urlParams = new URLSearchParams(window.location.search);
      var gameRenderingUrl = urlParams.get('gameRenderingUrl');
      this.setState({
        gameRenderingUrl: gameRenderingUrl
      });
      if (gameRenderingUrl) {
        return gameRenderingUrl;
      }
      var game = this.props.game;
      if (game.renderingType === 'External') {
        return this.props.game.version;
      }
      if (game.renderingType === 'Html') {
        var assetOriginUrl = this.getAssetOriginUrl((_b = game.sdkName) !== null && _b !== void 0 ? _b : game.slug, game.version);
        return "".concat(assetOriginUrl, "index.html");
      }
      //Babel build process transforms this value
      var PACKAGE_VERSION_STRING = "0.1.121";
      var iframeFilename = 'iframe-rendering-grm.html';
      var version = PACKAGE_VERSION_STRING ? ''.concat(PACKAGE_VERSION_STRING, '/') : '';
      var envName = this.props.arenaEnvironment || 'dev';
      var gameIdParam = ['gameId', (_c = this.gameId) !== null && _c !== void 0 ? _c : ''];
      var envParam = ['env', envName];
      [gameIdParam, envParam].forEach(function (pair) {
        return urlParams.set(pair[0], pair[1]);
      });
      return "".concat(CONSTS.IFRAME_BASE_URL).concat(version).concat(iframeFilename, "?").concat(urlParams.toString());
    },
    enumerable: false,
    configurable: true
  });
  GameRenderingModule.prototype.getArkadiumSdkInstance = function () {
    return null;
  };
  GameRenderingModule.prototype.componentDidMount = function () {
    var _a, _b;
    this.onResize();
    var isIframeGame = this.props.isIframeGame;
    if (isIframeGame) {
      window.addEventListener('message', this.onGameEvent);
      if (this.iframeRef.current) {
        this.loadArkadiumSdk(this.iframeRef.current.contentWindow);
      }
    } else {
      this.loadGameSdk();
      this.loadArkadiumSdk(window);
      this.gameSubject.xSubscribe(this.onGameEvent);
    }
    window.addEventListener('resize', this.onResize);
    window.addEventListener('message', this.onMessage);
    window.addEventListener(EnumPlatformEventTypes.BACK_TO_GAME, this.onBackToGame);
    setGamePurchaseRequestResult(null);
    var addEventHandlers = this.props.addEventHandlers;
    (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.onUnitMount) === null || _b === void 0 ? void 0 : _b.call(_a);
    if (addEventHandlers) {
      Object.keys(addEventHandlers).forEach(function (key) {
        window.addEventListener(key, addEventHandlers[key]);
      });
    }
  };
  GameRenderingModule.prototype.componentDidUpdate = function (prevProps) {
    var _a, _b, _c;
    // for sending AUTH_API_EVENT callback action when outer logic done
    var _d = this.props,
      user = _d.user,
      isIframeGame = _d.isIframeGame;
    // When iframe game requested to login and user logged in
    if (((_a = prevProps === null || prevProps === void 0 ? void 0 : prevProps.user) === null || _a === void 0 ? void 0 : _a.uid) !== (user === null || user === void 0 ? void 0 : user.uid)) {
      // fixes #144571, #146488
      // will work when games/eagle-user-client update lets handle this
      this.postMessageToIframe({
        type: EnumIframeMessageTypes.AUTH_API_EVENT,
        payload: {
          auth_method: EnumIframeAuthActions.CHECK_AUTH
        }
      });
    }
    (_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.onUnitUpdate) === null || _c === void 0 ? void 0 : _c.call(_b, prevProps, this.props);
    if (!isIframeGame && this.props.isStateGamePlaying) {
      checkFPS();
    }
  };
  GameRenderingModule.prototype.componentWillUnmount = function () {
    var _a, _b, _c, _d;
    var isIframeGame = this.props.isIframeGame;
    if (isIframeGame) {
      window.removeEventListener('message', this.onGameEvent);
    } else {
      this.gameSubject.xUnsubscribe();
      (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.doSetGameObservable) === null || _b === void 0 ? void 0 : _b.call(_a, null);
    }
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('message', this.onMessage);
    window.removeEventListener(EnumPlatformEventTypes.BACK_TO_GAME, this.onBackToGame);
    setGamePurchaseRequestResult(null);
    (_d = (_c = this.props) === null || _c === void 0 ? void 0 : _c.onUnitUnmount) === null || _d === void 0 ? void 0 : _d.call(_c);
    var addEventHandlers = this.props.addEventHandlers;
    if (addEventHandlers) {
      Object.keys(addEventHandlers).forEach(function (key) {
        window.removeEventListener(key, addEventHandlers[key]);
      });
    }
  };
  GameRenderingModule.prototype.render = function () {
    var _a, _b;
    var _c = this.props,
      keepAliveStatus = _c.keepAliveStatus,
      isIframeGame = _c.isIframeGame,
      game = _c.game;
    var isGameActive = this.props.isStateGamePlaying;
    var keepAlive = keepAliveStatus === false ? false : true;
    return React.createElement(UnitContainer, {
      "data-element-description": "game",
      ref: this.unitContainerRef,
      hidden: !isGameActive || !keepAlive,
      className: classnames.apply(void 0, __spreadArray(__spreadArray([], ((_a = this.props) === null || _a === void 0 ? void 0 : _a.customCssClassesUnitContainer) || [], true), ['__GRM'], false))
    }, React.createElement(CanvasContainer, {
      ref: this.canvasContainerRef,
      className: classnames.apply(void 0, __spreadArray([styles.canvasContainer], ((_b = this.props) === null || _b === void 0 ? void 0 : _b.customCssClassesCanvasContainer) || [], true))
    }, React.createElement(GameCanvas, {
      id: "game-canvas",
      isIframeGame: isIframeGame,
      iframeSourceCode: this.iframeSourceCode,
      onIframeLoad: this.onIframeLoad,
      onSdkIframeLoad: this.onSdkIframeLoad,
      iframeRef: this.iframeRef,
      game: game,
      topLevelClassname: styles.gameCanvas,
      customCssClassesCanvasBoxWrapper: this.props.customCssClassesCanvasBoxWrapper || [],
      customCssClassesCanvasBox__common: this.props.customCssClassesCanvasBox__common || [],
      customCssClassesCanvasBox__iframe: this.props.customCssClassesCanvasBox__iframe || [],
      isArkadiumSdkGame: this.state.isArkadiumSdkGame
    })), this.state.isGameLoading && React.createElement(GameLoader, null));
  };
  return GameRenderingModule;
}(React.PureComponent);
export { GameRenderingModule };
var UnitContainer = React.forwardRef(function (_a, ref) {
  var _b;
  var hidden = _a.hidden,
    customCssClassesUnitContainer = _a.customCssClassesUnitContainer,
    _ = _a._,
    props = __rest(_a, ["hidden", "customCssClassesUnitContainer", "_"]);
  return React.createElement("div", __assign({
    ref: ref
  }, props, {
    className: classnames.apply(void 0, __spreadArray(__spreadArray([styles.unitContainer], customCssClassesUnitContainer || [], true), [(_b = {}, _b[styles.hidden] = hidden, _b)], false))
  }));
});
var CanvasContainer = React.forwardRef(function (props, ref) {
  return React.createElement("div", __assign({}, props, {
    ref: ref
  }));
});